import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { MdAdd } from 'react-icons/md';

import colors from 'config/colors';
import { permissions } from 'config/permissions';

import * as suppliersThunks from 'thunks/suppliers';
import * as suppliersReducer from 'reducers/suppliers';

import Page from 'components/Page';
import Modal from 'components/Modal';
import CloseButton from 'components/CloseButton';
import Button from 'components/Button';
import EmptyCard from 'components/EmptyCard';
import Feature from 'components/Feature';

import Suppliers from './Suppliers';
import SettingsHeader from '../Settings/SettingsHeader';
import SupplierDetail from './SupplierDetail';
import './styles.scss';

const styles = {
  modalContentStyles: {
    width: 'min(920px, calc(100% - 48px))',
    maxWidth: 920,
    overflow: 'hidden',
    backgroundColor: colors.white,
    borderRadius: 8,
  },
};

const { func, shape, string, number, object } = PropTypes;

class SuppliersContainer extends Component {

  static propTypes = {
    dispatch: func.isRequired,
    screen: shape({
      width: number.isRequired,
      height: number.isRequired,
      size: string.isRequired,
    }).isRequired,
    suppliersData: object,
    supplierKey: string,
    orgKey: string,
  }

  static defaultProps = {
    suppliersData: {},
    supplierKey: null,
    orgKey: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      supplierModalIsOpen: false,
      infoModalIsOpen: false,
      infoModalText: '',
    };
  }

  componentDidMount() {
    this.props.dispatch(suppliersThunks.startWatchingSuppliers(this.props.orgKey));
  }

  componentWillUnmount() {
    this.props.dispatch(suppliersThunks.stopWatchingSuppliers());
  }

  openSupplierModal = (supplierKey) => {
    this.props.dispatch(suppliersReducer.setSupplierKey(supplierKey));
    this.setState({
      supplierModalIsOpen: true,
    });
  }

  newSupplier = () => {
    this.props.dispatch(suppliersReducer.setSupplierKey(null));
    this.setState({
      supplierModalIsOpen: true,
    });
  }

  closeSupplierModal = () => {
    this.setState({ supplierModalIsOpen: false });
    this.props.dispatch(suppliersReducer.setSupplierKey(null));
  }

  closeInfoModal = () => {
    this.setState({
      infoModalIsOpen: false,
      infoModalText: '',
    });
  }

  render() {
    const modalTitle = this.props.suppliersData && this.props.suppliersData[this.props.supplierKey] ?
      this.props.suppliersData[this.props.supplierKey].companyName : 'New Supplier';
    const isNewSupplier = !this.props.supplierKey;
    const modalHeight = { maxHeight: this.props.screen.height * 0.9 };
    const supplierCount = Object.keys(this.props.suppliersData || {}).length;

    return (
      <div>
        <Page
          title="Suppliers"
        >
          <SettingsHeader selectedTabKey="suppliers" />
          <main className="suppliers-page">
            <header className="suppliers-page__toolbar">
              <div>
                <h2 className="suppliers-page__title">Suppliers</h2>
                <p className="suppliers-page__description">
                  Manage supplier organisations, contact details, and tier assignments.
                  {' '}{supplierCount} {supplierCount === 1 ? 'supplier' : 'suppliers'} configured.
                </p>
              </div>
              <Feature permissionRequired={permissions.VMS_CAN_MANAGE}>
                <Button
                  black
                  shadow={false}
                  className="suppliers-page__new-button"
                  onClick={this.newSupplier}
                >
                  <MdAdd /> New supplier
                </Button>
              </Feature>
            </header>

            {supplierCount > 0 ?
              <Suppliers
                suppliersData={this.props.suppliersData}
                openSupplierModal={this.openSupplierModal}
              /> :
              <EmptyCard
                dimensions={{ height: 260 }}
                message="No suppliers found"
              />
            }
          </main>
        </Page>

        <Modal
          isOpen={this.state.supplierModalIsOpen}
          padding={0}
          contentLabel="Supplier Details"
          onRequestClose={this.closeSupplierModal}
          contentStyle={{ ...styles.modalContentStyles, ...modalHeight }}
        >
          <CloseButton handleClose={this.closeSupplierModal} top={18} right={18} />
          <SupplierDetail
            title={modalTitle}
            isNewSupplier={isNewSupplier}
            isOpen={this.state.supplierModalIsOpen}
            closeSupplierModal={this.closeSupplierModal}
          />
        </Modal>

        <Modal
          isOpen={this.state.infoModalIsOpen}
          contentLabel="Info"
          onRequestClose={this.closeInfoModal}
        >
          <div>
            <h2 className="supplier-modal-message">{this.state.infoModalText}</h2>
          </div>
        </Modal>

      </div>
    );
  }
}

function mapStateToProps({ screen, suppliers, global }) {
  const empAuthOrgs = global.employerAuthorisedOrgs || {};
  const orgKey = Object.keys(empAuthOrgs)[0] || null;
  const suppliersData = suppliers.suppliersData || {};
  const { supplierKey } = suppliers;
  return {
    screen,
    orgKey,
    suppliersData,
    supplierKey,
  };
}

export default withRouter(connect(mapStateToProps)(SuppliersContainer));
